import { createFileRoute } from '@tanstack/react-router';
import type { AppEmbed as AppEmbedType } from '@thoughtspot/visual-embed-sdk';
import { AppEmbed, useEmbedRef } from '@thoughtspot/visual-embed-sdk/react';
import { useUserAppViewConfig } from '@/api/queries/useSdkTokenQuery';

/**
 * DEEP LINK ROUTE: Manage Notification Preferences
 *
 * This route handles external/email links that direct users to ThoughtSpot's
 * notification preferences page. It uses a standalone AppEmbed to render the
 * native ThoughtSpot experience within the dashboard shell.
 *
 * URL Pattern: /dashboard/user-preference
 */
export const Route = createFileRoute('/dashboard/_deep-links/user-preference')({
  component: RouteComponent,
});

function RouteComponent() {
  const embedRef = useEmbedRef() as React.RefObject<AppEmbedType>;
  const userAppViewConfig = useUserAppViewConfig();

  return (
    <AppEmbed
      className="h-[calc(100vh-var(--dashboard-menu-height))] w-full"
      ref={embedRef}
      // TODO: waiting for TS support verification whether the flag also needs to be explicitly passed on those deep-link routes
      // enableCustomColumnGroups={true}
      // additionalFlags={{ enableCustomColumnGroups: true }}
      path="user-preference"
      {...(userAppViewConfig?.hiddenActions && {
        hiddenActions: userAppViewConfig.hiddenActions,
      })}
      {...(userAppViewConfig?.homePageSearchBarMode && {
        homePageSearchBarMode: userAppViewConfig.homePageSearchBarMode,
      })}
    ></AppEmbed>
  );
}
